<template>
  <div>
    Détail utilisateur
  </div>
</template>

<script>

export default {
  name: 'users_show',
  data () {
    return{
    }
  },
  mounted:function(){
  },
  activated:function(){
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// show.vue?2938c310